// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "sensor_service.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Defines the SensorService service, and its request/response types
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { SensorService } from "./sensor_service";
import type { StreamReadingsResponse } from "./sensor_service";
import type { StreamReadingsRequest } from "./sensor_service";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetReadingsResponse } from "./sensor_service";
import type { GetReadingsRequest } from "./sensor_service";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * *
 * Allows sensor readings to be queried
 *
 * @generated from protobuf service aeolus.proto.SensorService
 */
export interface ISensorServiceClient {
    /**
     * *
     * Fetch a set of sensor readings for a given device
     *
     * @generated from protobuf rpc: GetReadings(aeolus.proto.GetReadingsRequest) returns (aeolus.proto.GetReadingsResponse);
     */
    getReadings(input: GetReadingsRequest, options?: RpcOptions): UnaryCall<GetReadingsRequest, GetReadingsResponse>;
    /**
     * *
     * Stream a set of sensor readings for a given device
     *
     * No aggregation is supported on this endpoint
     *
     * @generated from protobuf rpc: StreamReadings(aeolus.proto.StreamReadingsRequest) returns (stream aeolus.proto.StreamReadingsResponse);
     */
    streamReadings(input: StreamReadingsRequest, options?: RpcOptions): ServerStreamingCall<StreamReadingsRequest, StreamReadingsResponse>;
}
/**
 * *
 * Allows sensor readings to be queried
 *
 * @generated from protobuf service aeolus.proto.SensorService
 */
export class SensorServiceClient implements ISensorServiceClient, ServiceInfo {
    typeName = SensorService.typeName;
    methods = SensorService.methods;
    options = SensorService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * *
     * Fetch a set of sensor readings for a given device
     *
     * @generated from protobuf rpc: GetReadings(aeolus.proto.GetReadingsRequest) returns (aeolus.proto.GetReadingsResponse);
     */
    getReadings(input: GetReadingsRequest, options?: RpcOptions): UnaryCall<GetReadingsRequest, GetReadingsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetReadingsRequest, GetReadingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * *
     * Stream a set of sensor readings for a given device
     *
     * No aggregation is supported on this endpoint
     *
     * @generated from protobuf rpc: StreamReadings(aeolus.proto.StreamReadingsRequest) returns (stream aeolus.proto.StreamReadingsResponse);
     */
    streamReadings(input: StreamReadingsRequest, options?: RpcOptions): ServerStreamingCall<StreamReadingsRequest, StreamReadingsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<StreamReadingsRequest, StreamReadingsResponse>("serverStreaming", this._transport, method, opt, input);
    }
}
